import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCartTotal } from '../../redux/CartSlice'
import { Rupee } from '../index'
import { delivery_charge } from '../../base'

function CartDescription() {
    const { cart_total, cart_item } = useSelector((state) => state.cartSlice)
    const cart_total_item = useSelector((state) => state.appSlice.cart_total_item)
    const [totalProduct, setTotalProduct] = useState(0)
    const [total, setTotal] = useState(0)
    const dispatch = useDispatch()

    // runs first to get total amount and total products
    useEffect(() => {
        dispatch(getCartTotal())
        setTotalProduct(
            cart_item ? cart_item.reduce((sum, item) => sum + item.quantity, 0) : cart_total_item
        )
    }, [cart_item])


    useEffect(() => {
        setTotal((cart_total) + (totalProduct * delivery_charge))
    }, [cart_total, totalProduct])

    return (
        <div className='cartDescription'>
            <div className='d-flex h6 justify-content-between'>
                <div >Total Products : </div>
                <div >{totalProduct}</div>
            </div>
            <div className='d-flex h6 justify-content-between'>
                <div >Cart Total : </div>
                <div ><Rupee className={'justify-content-end'} amount={cart_total} /></div>
            </div>
            <div className='d-flex h6 justify-content-between'>
                <div >Delivery Charge : </div>
                <div className='h6' style={{ display: 'flex', justifyContent: 'end', width: '20%', gap: '7px' }}>+ <del>{totalProduct * 100}</del><Rupee amount={delivery_charge}/></div>
            </div>
            <hr className='mt-2 mb-2' />
            <div className='d-flex h6 justify-content-between scolor'>
                <div >Grand Total ( To pay ) : </div>
                <div ><Rupee amount={total} className={'justify-content-end'} /></div>
            </div>
            <div className='d-flex h7 justify-content-between focolor'>
                <div>You are saving : </div>
                <div ><Rupee amount={(totalProduct * 100) - (totalProduct * delivery_charge)} className={'justify-content-end'} /></div>
            </div>
            <div className='d-flex h7 justify-content-between'>
                <div style={{}}>Payment Method : </div>
                <div>Online Payment</div>
            </div>
            <div className='d-flex h7 justify-content-between'>
                <div style={{}}>Excpected Delivery in : </div>
                <div>5-10 (Business Days)</div>
            </div>
        </div>
    )
}

export default CartDescription